export const TECHNICIAN_ROLE = 'TECHNICIAN';
export const CUSTOMER_ADMIN_ROLE = 'CUSTOMER_ADMIN';
